import { tryFetch, HttpMethod, type HttpResponse } from '@/modules/services/http'
import type { AuthErrorCode } from '../types/auth.enums'
import type { ClaimResponse } from '../models/auth.models'
import type { UserErrorCode } from '@/modules/users/types/user.enums'
import type { Identity } from '@/modules/users/models/user.model'

const USER_SESSION_BASE_URL = import.meta.env.VITE_USER_SESSION_API_URL
const MAIN_BASE_URL = import.meta.env.VITE_MAIN_BASE_URL

const getIdentity = async (): Promise<HttpResponse<Identity | null, UserErrorCode>> =>
  await tryFetch<Identity | null, UserErrorCode>(HttpMethod.Get, MAIN_BASE_URL, [
    'auth',
    'identity',
  ])

const exchangeCode = async (
  code: string,
  state: string,
  redirectUri: string,
): Promise<HttpResponse<ClaimResponse, AuthErrorCode>> =>
  await tryFetch<ClaimResponse, AuthErrorCode>(
    HttpMethod.Post,
    USER_SESSION_BASE_URL,
    ['auth', 'exchange-code'],
    {
      body: { code, state, redirectUri },
    },
  )

const exchangeSession = async (): Promise<HttpResponse<null, AuthErrorCode>> =>
  await tryFetch<null, AuthErrorCode>(HttpMethod.Post, USER_SESSION_BASE_URL, [
    'auth',
    'exchange-session',
  ])

const tryLogout = async (): Promise<HttpResponse<null, AuthErrorCode>> =>
  await tryFetch<null, AuthErrorCode>(HttpMethod.Post, USER_SESSION_BASE_URL, ['auth', 'logout'])

export const authApi = {
  getIdentity,
  exchangeCode,
  exchangeSession,
  tryLogout,
}
